import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const InputFile = styled.input``;

export const SignatureContainer = styled.div`
  position: absolute;
  width: 400px;
  height: 210px;
  background: #dddddd;
  border-radius: 10px;
  z-index: 99999;
`;

interface ButtonSignatureProps {
  tipo: 'send' | 'delete';
  size: number;
}

export const ButtonSignature = styled.button<ButtonSignatureProps>`
  width: ${({ size }) => size}%;
  height: 40px;
  background-color: ${({ tipo }) => tipo === 'send' ? styleSheet.colorMain : styleSheet.cancel};
  border: 0;
  color: #fff;
  cursor: pointer;
  border-radius: ${({ tipo }) => tipo === 'send' ? '0 0 10px 0' : '0 0 0 10px'};
`;

export const SignatureImage = styled.img`
  width: 400px;
  height: 160px;
  object-fit: contain;
  z-index: 99999;
`;

export const DefaultLabel = styled.label`
  font-size: 1.3rem !important;
`;












